import script from "./base-group-meeting-commitments-card.vue?vue&type=script&setup=true&lang=js"
export * from "./base-group-meeting-commitments-card.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__